import { FC, useCallback } from 'react';
import { Transition } from 'react-transition-group';
import { scrollToElement, remToPx, isElementInViewport } from '@edikk-edikk/shared';
import { useContentContext } from '@edikk-edikk/country-layout-black';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';
import AdvertListFilterContentCss from '#srcCssModules/advert/list-filter/advert-list-filter-content.module.scss';
import { Close } from '#advertList/components/filter/detail/Close';
import { FilterItemDetailList } from '#advertList/components/filter/detail/FilterItemDetailList';

const Detail: FC = () => {
  const {
    refDetail,
    refControls,
    isVisible,
  } = useFilterContext();
  const { refContent } = useContentContext();

  const handlerEnter = useCallback(() => {
    refDetail.current.style.height = `${refDetail.current.scrollHeight}px`;
    refDetail.current.style.opacity = '1';
    refDetail.current.style.marginTop = '0.5rem';
  }, [refDetail]);

  const handlerExit = useCallback(() => {
    refDetail.current.style.height = '0px';
    refDetail.current.style.opacity = '0';
    refDetail.current.style.marginTop = '0px';

    if (!isElementInViewport(refControls.current)) {
      scrollToElement(refControls.current, refContent.current, remToPx(1));
    }
  }, [refControls, refDetail, refContent]);

  return (
    <Transition
      in={isVisible}
      timeout={300}
      nodeRef={refDetail}
      onEnter={handlerEnter}
      onExit={handlerExit}
    >
      <div ref={refDetail} className={AdvertListFilterContentCss.advertListFilterContent}>
        <FilterItemDetailList />
        <Close />
      </div>
    </Transition>
  );
};

export { Detail };
